/**
 * The learning path of "Help & learning" (@digitalisation/enlixy-comp/onboarding):
 * events tracked from real actions (opening a machine, asking the assistant
 * ...), so the path is completed by working, not by reading. The package
 * keeps the progress per user in localStorage under `${LEARNING_KEY}:<sub>`;
 * Onboarding sets the user after login.
 */

import {
  createLearning,
  useLearning,
  type LearnTask as BaseTask,
} from "@digitalisation/enlixy-comp/onboarding";

export type LearnEvent =
  | "intro_seen"
  | "help_read"
  | "machine_opened"
  | "range_changed"
  | "chart_exported"
  | "compare_used"
  | "assistant_asked"
  | "tour_start"
  | "tour_machine"
  | "tour_assistant";

export type TourId = "start" | "machine" | "assistant";

/** What the button of an open task does (HelpSheet's runTask). */
export type TaskAction =
  | "intro"
  | "home"
  | "machine"
  | "compare"
  | "assistant"
  | `article:${string}`
  | `tour:${TourId}`;

export type LearnTask = BaseTask<LearnEvent, TaskAction>;

/** Kept stable across releases: users keep their progress. */
export const LEARNING_KEY = "performanceCockpit-learning.v1";

export const learning = createLearning<LearnEvent>({ storageKey: LEARNING_KEY });

export const track = (event: LearnEvent): void => learning.track(event);

/** The learning state; re-renders when an event is tracked. */
export const useLearningState = () => useLearning(learning);
